"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputWithButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const fi_1 = require("react-icons/fi");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaIconWrap_1 = require("../fela/FelaIconWrap");
const FelaLayers_1 = require("../fela/FelaLayers");
const FelaTextInput_1 = require("../fela/FelaTextInput");
const TextInputWithButton = ({ showButton = true, disabled = false, icon = (0, jsx_runtime_1.jsx)(fi_1.FiX, {}), onClickButton, outerDivStyle, buttonProps = {}, children, trackPadding, ...props }) => {
    // props.cssExtra = [...(props.cssExtra || [])];
    buttonProps.style = {
        position: "absolute",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)",
        ...buttonProps.style,
    };
    return ((0, jsx_runtime_1.jsxs)("div", { style: { position: "relative", ...outerDivStyle }, children: [(0, jsx_runtime_1.jsx)(FelaTextInput_1.FelaTextInput, { trackPadding: trackPadding ?? 60, padding: "0.5em 2em 0.5em 0.5em", disabled: disabled, ...props }), showButton && ((0, jsx_runtime_1.jsx)(FelaIconWrap_1.FelaIconWrap, { onClick: () => {
                    if (!disabled && onClickButton) {
                        onClickButton();
                    }
                }, noBackground: true, 
                // style={{ position: "absolute", right: 0, top: "50%", transform: "translateY(-50%)" }}
                margin: "0 0.5em", isButton: true, size: props.size ?? VibescoutFrontendStyleConfig_1.ETextSize.small, sizeNum: props.fontSize || 1, hoverable: true, height: FelaLayers_1.EFelaLayerHeight.HIGH, ...buttonProps, children: icon })), children] }));
};
exports.TextInputWithButton = TextInputWithButton;
